/* eslint-disable max-len */
const PersonalData = () => import(/* webpackChunkName: "PersonalData" */ '@/components/interveners/personal-data');
const ContactData = () => import(/* webpackChunkName: "ContactData" */ '@/components/interveners/contact-data');
const FiscalData = () => import(/* webpackChunkName: "FiscalData" */ '@/components/interveners/fiscal-data');
const PostalData = () => import(/* webpackChunkName: "PostalData" */ '@/components/interveners/postal-data');
const PositionStates = () =>
    import(/* webpackChunkName: "PositionStates" */ '@/components/interveners/position-states');

export default {
    /**
     * Nombre del componente
     */
    name: 'IntervenersDetailsInfo',

    /**
     * Componentes importados
     */
    components: {
        PersonalData,
        ContactData,
        FiscalData,
        PostalData,
        PositionStates
    },

    /**
     * @override
     */
    data() {
        return {
            dataIntervener: null,
            accountsWithPositions: [],
            loadingPositionStates: false,
            positionsGroupedByAccount: []
        };
    },

    props: {
        intervener: {
            type: Object,
            required: true
        },
        componentKey: {
            type: Number,
            required: false
        }
    },

    methods: {
        /**
         * @override
         */
        fetchData(res) {
            this.dataIntervener = res;
        },

        getAccountsWithPositions() {
            this.loadingPositionStates = true;
            this.$intervenersService
                .getIntervenerBalance(this.intervener.uuid)
                .then(response => {
                    this.loadingPositionStates = false;
                    this.accountsWithPositions = response.data.intervener_balance.accountsWithPositions;
                    this.groupPositionsByAccount();
                })
                .catch(err => console.error(err));
        },

        groupPositionsByAccount() {
            this.accountsWithPositions.forEach(account => {
                const accountPositions = account.positions;

                if (accountPositions.length) {
                    const accountPositionsSum = this.sumPositions(accountPositions);
                    accountPositionsSum.account = account.id_object;
                    accountPositionsSum.account_uuid = account.uuid;
                    accountPositionsSum.intervener_role = account.intervener_role;
                    this.positionsGroupedByAccount.push(accountPositionsSum);
                }
            });
        },

        sumPositions(positions) {
            const positionsSum = positions.reduce((prev, current) => ({
                current_amount: parseFloat(prev.current_amount) + parseFloat(current.current_amount),
                current_year_shares: parseFloat(prev.current_year_shares) + parseFloat(current.current_year_shares),
                purchase_amount: parseFloat(prev.purchase_amount) + parseFloat(current.purchase_amount),
                difference: parseFloat(prev.difference) + parseFloat(current.difference),
                profitability: parseFloat(prev.profitability) + parseFloat(current.profitability),
                shares: parseFloat(prev.shares) + parseFloat(current.shares),
                average_nav: parseFloat(prev.average_nav) + parseFloat(current.average_nav)
            }));

            positionsSum.profitability = (positionsSum.current_amount - positionsSum.purchase_amount) / positionsSum.purchase_amount;

            return positionsSum;
        }
    },

    /**
     * @override
     */
    beforeMount() {
        this.dataIntervener = this.intervener;
    },

    /**
     * @override
     */
    mounted() {
        this.getAccountsWithPositions();
    }
};
